import { render } from "./CategoryMonthlyExpense.vue?vue&type=template&id=e4d3597c"
import script from "./CategoryMonthlyExpense.vue?vue&type=script&lang=js"
export * from "./CategoryMonthlyExpense.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__